import { useSearchParams } from 'react-router-dom';
import dayjs, { Dayjs } from 'dayjs';
import { useCallback } from 'react';
import TableReservationList from '@client/page/management/table-reservation/list/table-reservation-list.tsx';
import { TableReservationSimpleFilter } from '@client/page/management/table-reservation/list/component/table-reservation-simple-filter.tsx';
import { TableReservationPaginationFooter } from '@client/page/management/table-reservation/list/component/table-reservation-pagination-footer.tsx';
import { ContentLayout, FullPrimaryContent } from '@packages/ui/content-layout.tsx';
import { useFocusedCompany } from '@packages/core/company/focused-company-context.ts';

const TableReservationSinglePage = () => {
  const [params, setParams] = useSearchParams();
  const { settings } = useFocusedCompany();

  const startTime = dayjs(params.get('startTime') ?? dayjs())
    .tz(settings.timezone)
    .startOf('day');
  const endTime = dayjs(params.get('endTime') ?? dayjs())
    .tz(settings.timezone)
    .endOf('day');

  // Function
  const setTime = useCallback(
    (start: Dayjs, end: Dayjs) => {
      params.set('startTime', start.toISOString());
      params.set('endTime', end.toISOString());
      setParams(params);
    },
    [params, setParams]
  );

  return (
    <ContentLayout>
      <FullPrimaryContent>
        <TableReservationList
          startTime={startTime}
          endTime={endTime}
          header={
            <TableReservationSimpleFilter
              startTime={startTime}
              endTime={endTime}
              onChange={(data) => {
                setTime(data[0], data[1]);
              }}
            />
          }
          footer={
            <TableReservationPaginationFooter
              startTime={startTime}
              endTime={endTime}
              onChange={(data) => {
                setTime(data[0], data[1]);
              }}
            />
          }
        />
      </FullPrimaryContent>
    </ContentLayout>
  );
};

export default TableReservationSinglePage;
